import {HubIdMap, HubsState, HubStatusMap} from '../state/hubs.state';
import {Actions, HUB_FETCHED, HUB_SAVED_TO_API, HUB_TUNNEL_CHECK, HUBS_USER_FETCHED} from '../actions/hubs.actions';

const initialState: HubsState = {
  hubs: {},
  statuses: {},
};

export function HubsReducer(state: HubsState = initialState, action: Actions): HubsState {
  const newStatuses: HubStatusMap = {...state.statuses};
  const newHubs: HubIdMap = {...state.hubs};

  switch (action.type) {
    case HUB_FETCHED:
      let hub = action.hub;

      newHubs[hub.ID] = hub;

      if (typeof newStatuses[hub.ID] === 'undefined') {
        newStatuses[hub.ID] = null;
      }

      return {
        ...state,
        hubs: newHubs,
      };
    case HUBS_USER_FETCHED:
      for (let h of action.hubs) {
        // Ensure there's a tunnel status entry for each hub, even though we don't know
        // status yet
        if (typeof newStatuses[h.ID] === 'undefined') {
          newStatuses[h.ID] = null;
        }

        newHubs[h.ID] = h;
      }

      return {
        ...state,
        hubs: newHubs,
        statuses: newStatuses,
      };
    case HUB_TUNNEL_CHECK:
      newStatuses[action.hubId] = action.status;

      return {
        ...state,
        statuses: newStatuses,
      };
    case HUB_SAVED_TO_API:
      newHubs[action.hub.ID] = action.hub;

      return {
        ...state,
        hubs: newHubs,
      };
    default:
      return state;
  }
}
